import { axiosConfig } from '../api/axios-config.js'

/**
 * 角色管理 API
 */
export const role = {
  /**
   * 取得角色列表或單一角色
   * @param {String|Object} idOrParams - 角色 ID 或查詢參數
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  get: (idOrParams, token) => {
    // 如果是物件且不是 token，表示是查詢參數（列表）
    if (typeof idOrParams === 'object' && idOrParams !== null && !idOrParams.headers) {
      return axiosConfig.get('/api/roles', {
        ...token,
        params: idOrParams
      });
    }
    // 如果是字串或數字，表示是 ID（單筆）
    return axiosConfig.get(`/api/roles${idOrParams ? `/${idOrParams}` : ''}`, token);
  },

  /**
   * 新增角色
   * @param {Object} data - 角色資料
   * @param {String} data.name - 角色名稱
   * @param {String} data.description - 角色描述
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  create: (data, token) => axiosConfig.post('/api/roles', data, token),

  /**
   * 更新角色
   * @param {Number} roleId - 角色 ID
   * @param {Object} data - 角色資料
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  update: (roleId, data, token) => axiosConfig.patch(`/api/roles/${roleId}`, data, token),

  /**
   * 刪除角色
   * @param {Number} roleId - 角色 ID
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  delete: (roleId, token) => axiosConfig.delete(`/api/roles/${roleId}`, token),

  /**
   * 取得可用權限列表（依群組分類）
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  getAvailablePermissions: (token) => axiosConfig.get('/api/roles/permissions/available', token),

  /**
   * 分配權限給角色
   * @param {Number} roleId - 角色 ID
   * @param {Object} data - 權限資料
   * @param {Array<Number>} data.permission_ids - 權限 ID 陣列
   * @param {Object} token - 授權 token object (含 headers)
   * @returns {Promise}
   */
  assignPermissions: (roleId, data, token) => axiosConfig.patch(`/api/roles/${roleId}/permissions`, data, token)
}
